import { Navigate, Route, Routes } from 'react-router-dom'
import React from 'react'

import { ManagersDashboard } from '../../../features/managers/components/dashboard'

export const ManagersPage = () => {
  return (
    <Routes>
      <Route path="/" element={<ManagersDashboard />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}
